import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(param) {
    var width = param.width, spin = param.spin;
    return /*#__PURE__*/ _jsx(Svg, {
        viewBox: "0 0 41 41",
        width: width,
        spin: spin,
        fill: "transparent",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M16.471 37.45A17.992 17.992 0 0 1 1.98 20.14a18.131 18.131 0 0 1 18.49-17.752A18.131 18.131 0 0 1 38.962 20.14 17.99 17.99 0 0 1 24.468 37.47M16.45 37.49l-1.959-5.537M16.45 37.49l-5.777 1.88",
            stroke: "#51FFC0",
            strokeWidth: "2.999",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
export default Icon;
